import {
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  Select,
} from "@mui/material";
import React from "react";

const CustomSelect = ({
  icon,
  children,
  placeholder,
  selectError,
  helperText,
  disabled = false,
  formStyleProps = {},
  ...props
}) => {
  const customStyle = {
    "&.MuiFormControl-root .MuiOutlinedInput-root .MuiInputBase-input": {
      padding: "10px",
      fontSize: "0.875rem",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      // paddingLeft: "6px",
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #cfcfcf`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #cfcfcf !important`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #cfcfcf !important`,
      },
    },
  };

  return (
    <FormControl
      fullWidth
      sx={{ ...formStyleProps, ...customStyle }}
      error={selectError}
      disabled={disabled}
    >
      <InputLabel>{placeholder}</InputLabel>
      <Select
        startAdornment={
          icon && <InputAdornment position="start">{icon}</InputAdornment>
        }
        {...props}
        label={placeholder}
        displayEmpty
      >
        {children}
      </Select>
      {selectError && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default CustomSelect;
